/**
 * The revamp's own state: the pins, per branch and per module, as channel ids. Persisted on both
 * apps (a device preference, as v1's pins are), and kept across a logout. The module settings are
 * NOT here: they stay in v1's shared `posSettingsStore.defaultModuleSettings` (decided 2026-10-07).
 */
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { ModuleKey } from "./types";

export interface ChannelPreferencesState {
  pins: Record<string, Partial<Record<ModuleKey, string[]>>>;
}

const initialState: ChannelPreferencesState = { pins: {} };

const slice = createSlice({
  name: "channelPreferences",
  initialState,
  reducers: {
    pinsSaved: (state, action: PayloadAction<{ branchId: string; module: ModuleKey; ids: string[] }>) => {
      const { branchId, module, ids } = action.payload;
      state.pins[branchId] = { ...state.pins[branchId], [module]: ids };
    },
  },
});

export const { pinsSaved } = slice.actions;
export const channelPreferencesReducer = slice.reducer;
